<template src="./WithFilterLayout.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import AppHeader from "@/components/AppHeader";
import SideMenu from "@/components/SideMenu";
import AppFooter from "@/components/AppFooter";

export default defineComponent({
    components: {
        AppHeader,
        SideMenu,
        AppFooter
    }
});
</script>

<style src="./WithFilterLayout.scss" lang="scss" scoped></style>
